<script>
    import {
        Alert,
        Row,
        InputText,
        FormBoxContainer,
        Disclosure,
        Button,
        InputFile,
        CheckBox,
        TextArea,
        Column,
    } from '$lib/components/UI'
    import { API_URL } from '$lib/conf'
    import { validarCuit, isPdf, isAsync } from '$lib/utils'
    import DocumentField from '$lib/components/UI/DocumentField.svelte'
    export let editable = false
    export let signup = false
    export let data = {}
    export let validations = {}
    export let valid = false
    export let bajaPermanenteHandler = (x) => x
    function validateFile(d) {
        return d instanceof Array && d.length > 0
            ? d.every((f) => isPdf(f?.filename) || false)
            : !signup
    }
    let bajapermanente = false
    $: valid = Object.values(validations).reduce((r, x) => r && x, true)
</script>

{#if data.lfstate === 'Deshabilitado'}
    <Alert type="warning">
        <strong>Motivo de deshabilitacion: </strong>
        {data.motivo_deshabilitacion}
    </Alert>
{/if}
<Row>
    <InputText
        maxLength={50}
        disabled={!editable}
        validation={(x) => x && x.length > 2}
        bind:valid={validations.nombre}
        bind:value={data.nombre}
        label="Nombre"
    />
    <InputText
        maxLength={50}
        disabled={!editable}
        validation={(x) => x && x.length > 2}
        bind:valid={validations.apellido}
        bind:value={data.apellido}
        label="Apellido"
    />
</Row>
<Row>
    <InputText
        label="CUIL"
        maxLength={11}
        disabled={!signup}
        validation={validarCuit}
        bind:valid={validations.cuit}
        bind:value={data.cuil}
    />
</Row>
<Row>
    <InputText
        label="Clave de alta temprana"
        maxLength={50}
        disabled={!editable}
        validation={(x) => x}
        bind:valid={validations.clave_de_alta_temprana}
        bind:value={data.clave_de_alta_temprana}
    />
    <InputText
        label="Cobertura de riesgo de trabajo"
        maxLength={50}
        disabled={!editable}
        validation={(x) => x}
        bind:valid={validations.cobertura_de_riesgo_de_trabajo}
        bind:value={data.cobertura_de_riesgo_de_trabajo}
    />
</Row>
<Row>
    <InputText
        label="Cuenta corriente"
        maxLength={20}
        disabled={!editable}
        bind:value={data.cuenta_corriente}
    />
</Row>
{#if !editable}
    {#if data.docs}
        <FormBoxContainer title="Adjuntos">
            {#each data.docs as doc}
                <DocumentField
                    preview
                    {...doc}
                    on:preview={(_) =>
                        window.open(
                            `${API_URL}/download/${doc.uuid
                                .split('.')
                                .at(0)}/preview`,
                            '',
                            'width=566,height=800,scrollbars=NO'
                        )}
                    on:download={(_) => {
                        window.open(`${API_URL}/download/${doc.uuid}`, '_blank')
                    }}
                />
            {/each}
        </FormBoxContainer>
    {/if}
    {#if ['Habilitado', 'Deshabilitado'].includes(data.lfstate)}
        <br /><br />
        <Disclosure label="Operaciones">
            <span
                style="width: 100%; display: flex; flex-direction: row; gap: 25px"
            >
                {#if bajapermanente}
                    <span
                        style="position: relative; width: 100%; height: auto; display: flex; flex-direction: row"
                    >
                        <Row>
                            <TextArea
                                maxLength={120}
                                bind:value={data.motivo_deshabilitacion}
                                label="Motivo de baja"
                            />
                        </Row>
                        <Column>
                            <Button
                                type="other"
                                on:click={() => {
                                    bajapermanente = false
                                    data.motivo_deshabilitacion = undefined
                                }}>Cancelar</Button
                            >
                            <Button
                                disabled={data.motivo_deshabilitacion?.length <=
                                    2}
                                on:click={bajaPermanenteHandler}
                                >Confirmar baja</Button
                            >
                        </Column>
                    </span>
                {:else}
                    <Button on:click={() => (bajapermanente = true)}
                        >Baja permanente</Button
                    >
                {/if}
            </span>
        </Disclosure>
    {/if}
{:else}
    <InputFile
        validation={validateFile}
        label={`Constancia de pago de remuneracion${!signup ? ' (Opcional)' : ''}`}
        endpoint={API_URL + '/upload'}
        bind:valid={validations.constancia_pago_remuneracion}
        bind:value={data.constancia_pago_remuneracion}
        style="margin: 0 0 20px 0"
    />
    <InputFile
        validation={validateFile}
        label={`Copia de pago de seguridad${!signup ? ' (Opcional)' : ''}`}
        endpoint={API_URL + '/upload'}
        bind:valid={validations.copia_pago_seguridad}
        bind:value={data.copia_pago_seguridad}
    />
    {#if !validations.copia_pago_seguridad || !validations.constancia_pago_remuneracion}
        <Alert style="margin: 15px 0 0 0" type="error"
            >{signup
                ? 'Ambos adjuntos son requeridos y deben subirse en formato PDF'
                : 'Los adjuntos deben subirse en formato PDF'}</Alert
        >
    {/if}
    {#if !signup}
        <Row>
            <CheckBox
                disabled={!editable}
                label="Activo"
                bind:valid={validations.active}
                bind:value={data.active}
            />
        </Row>
    {/if}
{/if}
